/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TerminalStatusResponse
 */
export interface TerminalStatusResponse {
    /**
     * 
     * @type {TerminalStatusResponseLatestStateEnum}
     * @memberof TerminalStatusResponse
     */
    latestState: TerminalStatusResponseLatestStateEnum;
    /**
     * 
     * @type {string}
     * @memberof TerminalStatusResponse
     */
    pspTerminalId: string;
}


/**
 * @export
 */
export const TerminalStatusResponseLatestStateEnum = {
    UNKNOWN: 'UNKNOWN',
    OK: 'OK',
    BUSY: 'BUSY',
    MAINTENANCE: 'MAINTENANCE',
    UNREACHABLE: 'UNREACHABLE',
    OUT_OF_ORDER: 'OUT_OF_ORDER'
} as const;
export type TerminalStatusResponseLatestStateEnum = typeof TerminalStatusResponseLatestStateEnum[keyof typeof TerminalStatusResponseLatestStateEnum];


/**
 * Check if a given object implements the TerminalStatusResponse interface.
 */
export function instanceOfTerminalStatusResponse(value: object): value is TerminalStatusResponse {
    if (!('latestState' in value) || value['latestState'] === undefined) return false;
    if (!('pspTerminalId' in value) || value['pspTerminalId'] === undefined) return false;
    return true;
}

export function TerminalStatusResponseFromJSON(json: any): TerminalStatusResponse {
    return TerminalStatusResponseFromJSONTyped(json, false);
}

export function TerminalStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TerminalStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'latestState': json['latestState'],
        'pspTerminalId': json['pspTerminalId'],
    };
}

export function TerminalStatusResponseToJSON(json: any): TerminalStatusResponse {
    return TerminalStatusResponseToJSONTyped(json, false);
}

export function TerminalStatusResponseToJSONTyped(value?: TerminalStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'latestState': value['latestState'],
        'pspTerminalId': value['pspTerminalId'],
    };
}

